import { useTranslation } from 'react-i18next'
import cx from 'helpers/cx'
import {
    isSameDate,
    isSameTime,
    showTime,
    showWeekDay,
} from 'helpers/date/showDate'
import filterViewerFromAttendees from 'helpers/filterViewerFromAttendees'

import People from 'js/components/People'

import type { EventGuestListWrapperQuery } from '../EventGuestListPage/GuestList.queries.generated'

import DateCalendar from './DateCalendar'
import styles from './EventDataSummary.module.css'
import HiddenEventDates from './HiddenEventDates'

type Props = {
    viewer: EventGuestListWrapperQuery['viewer']
    entity: Extract<
        EventGuestListWrapperQuery['entity'],
        { __typename: 'Event' }
    >
    [key: string]: any
}

const EventDataSummary = ({ viewer, entity, ...rest }: Props) => {
    const { t } = useTranslation()
    const { className, ...domRest } = rest

    if (!entity) {
        return null
    }

    const { startDate, endDate, attendees, isAttending } = entity
    const sameDate = isSameDate(startDate, endDate)
    const sameTime = isSameTime(startDate, endDate)

    return (
        <>
            <HiddenEventDates startDate={startDate} endDate={endDate} />
            <div
                aria-hidden
                className={cx(styles.wrapper, className)}
                {...domRest}
            >
                <DateCalendar
                    startDate={startDate}
                    size="normal"
                    style={{ marginRight: '12px' }}
                />

                <div style={{ padding: '4px 0' }}>
                    <div className={styles.time}>
                        {showWeekDay(startDate)} {showTime(startDate)}
                        {!!endDate && !sameTime ? (
                            <span>
                                {' '}
                                – {sameDate ? '' : `${showWeekDay(endDate)} `}
                                {showTime(endDate)}
                            </span>
                        ) : null}
                    </div>

                    <People
                        size="small"
                        showCheck={isAttending === 'accept'}
                        checkLabel={t('entity-event.you-are-going')}
                        users={
                            isAttending === 'accept'
                                ? filterViewerFromAttendees(
                                      attendees.edges,
                                      viewer.user.guid,
                                  )
                                : attendees.edges
                        }
                        total={attendees.totalAccept}
                        style={{
                            marginTop: '4px',
                            justifyContent: 'flex-start',
                        }}
                    />
                </div>
            </div>
        </>
    )
}

export default EventDataSummary
